import { IntlFormatters } from "react-intl";

export const getYearOptions = () => {
    let currentYear = new Date().getFullYear();
    return [
        {
            label: currentYear.toString(),
            value: currentYear,
        },
        {
            label: (currentYear + 1).toString(),
            value: currentYear + 1,
        },
    ];
};

export const getMonthOptions = (formatDate: IntlFormatters["formatDate"]) => {
    let start = 1547424000000;
    let months = [];
    for (let m = 0; m < 12; m++) {
        months.push({
            value: m,
            label: formatDate(start + m * 1000 * 60 * 60 * 24 * 30, { month: "long" }),
        });
    }
    return months;
};

const monthLengths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const getDateOptions = (year: number, month: number, formatDate: IntlFormatters["formatDate"]) => {
    let dates = [];
    for (let d = 1; d <= monthLengths[month]; d++) {
        dates.push({
            value: d,
            label: `${d} (${formatDate(new Date(year, month, d), { weekday: "short" })})`,
        });
    }

    if (year % 4 === 0 && month === 1) {
        dates.push({
            value: 29,
            label: `29 (${formatDate(new Date(year, month, 29), { weekday: "short" })})`,
        });
    }

    return dates;
};

export const getHourOptions = () => {
    let hours = [];
    for (let h = 0; h < 24; h++) {
        hours.push({
            value: h,
            label: h.toString(),
        });
    }
    return hours;
};

export const getMinuteOptions = () => {
    let minutes = [];
    for (let h = 0; h < 60; h++) {
        minutes.push({
            value: h,
            label: ("0" + h).slice(-2),
        });
    }
    return minutes;
};
